module.exports = require('react/lib/update');


/*****************
 ** WEBPACK FOOTER
 ** ./~/react-addons-update/index.js
 ** module id = 149
 ** module chunks = 0
 **/